import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/economicFactors';

export default function EconomicFactors() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Everything in exam section 2.1, in one place: business cycles, monetary and fiscal policy, financial reporting, analytical methods, and the types of risk — not covered by the Uniform Securities Act, Investment Advisers Act, or Model Rules, since those are law, not economics."
      parts={parts}
    />
  );
}
